module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-plan-estimate_sample-8b589f773a5842381b30c43fdff224a4.png";